<template>
  <div class="field-label">
    <v-icon v-if="icon" size="20">{{ icon }}</v-icon>
    <span>{{ label }}</span>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    label: string;
    icon?: string;
  }>(),
  {
    icon: "",
  },
);
</script>

<style scoped>
.field-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--color-subtitle);
  font-weight: 500;
  font-size: 14px;
  
}
</style>
